import { Form, useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import React, { useCallback, useState } from 'react';
import { Badge } from 'react-bootstrap';
import Button from 'react-bootstrap/esm/Button';
import { SuggestField } from 'src/libs/ui-kit/inputs/Suggest';

import { useProfileWidgetStore } from './StoreProvider';
import { LoaderButton } from '../../../../../libs/ui-kit/buttons/LoaderButton';
import { PlatformAdminApi } from '../../../../../services/GrpcService';
import { FieldError } from '../../../../../libs/ui-kit';
import styles from '../../../UsersList.styles.module.scss';

export const BlockingForm = observer((): JSX.Element => {
  const {
    blockingModal: { hide },
    profile,
    searchBlockingReasons,
    blockProfileInProgress,
  } = useProfileWidgetStore();

  const [isPermanent] = useState<boolean>(false);
  const [reasonEmpty, setReasonEmpty] = useState<boolean>(false);
  const { submitForm, resetForm, isValid, isSubmitting, validateForm, values } = useFormikContext<{
    reason: PlatformAdminApi.UserBlockingReason;
  }>();

  const onModalCancel = useCallback(() => {
    hide();
    resetForm();
  }, [hide, resetForm]);

  const onModalSubmit = async () => {
    setReasonEmpty(!values.reason);

    await submitForm();
    resetForm();

    return validateForm();
  };

  const isBlockDisabled = !isValid || isSubmitting || blockProfileInProgress;

  return (
    <Form className={styles.reason}>
      <div className="text-muted">Пользователь</div>
      <div className="mb-4">{profile?.fullName}</div>
      {isPermanent && (
        <Badge variant="danger" className="mb-2">
          Внимание! Вы не сможете отменить операцию.
        </Badge>
      )}
      <SuggestField
        name="reason"
        placeholder="Выберите причину"
        optionLabelKey="label"
        optionValueKey="value"
        search={searchBlockingReasons}
        disabled={blockProfileInProgress}
      />
      <div className={styles.error}>{reasonEmpty && <FieldError error="Поле обязательно" />}</div>
      <div className="d-flex">
        <div className="mr-1 d-flex" style={{ width: '136px' }}>
          <LoaderButton
            variant="danger"
            isLoading={blockProfileInProgress}
            disabled={isBlockDisabled}
            onClick={onModalSubmit}>
            Заблокировать
          </LoaderButton>
        </div>
        <Button variant="light" className="mx-1" onClick={onModalCancel} disabled={blockProfileInProgress}>
          Отменить
        </Button>
      </div>
    </Form>
  );
});
